import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BorderInnerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"border_inner"}/>
}
